// extracted by mini-css-extract-plugin
module.exports = {"second-column":"Header_second-column__1v7ns","full-width":"Header_full-width__A4iN8","content-to-right":"Header_content-to-right__2efuh","title":"Header_title__1Ltr0"};